import React from 'react';

const Footer = () => {
  const galleryImages = [
    'assets/images/Hope-Spring-Water-Charity.jpg',
    'assets/images/21.jpg',
    'assets/images/affordable-healthcare.jpg',
    'assets/images/22.webp',
    'assets/images/1.jpg',
    'assets/images/2.jpg',
    // 'assets/images/3.webp',
    // 'assets/images/7.webp',
  ];

  return (
    <footer className="site-footer">
      <div className="site-footer__newsletter">
        <div className="container">
          <div className="site-footer__newsletter-inner">
            <div className="site-footer__newsletter-left">
              <div className="site-footer__newsletter-title-box">
                <h3 className="site-footer__newsletter-title">Subscribe Our Newsletters</h3>
              </div>
            </div>
            <div className="site-footer__newsletter-right">
              <div className="site-footer__newsletter-content">
                <form className="site-footer__newsletter-form">
                  <div className="site-footer__newsletter-input">
                    <input type="text" placeholder="Enter Your Email" />
                  </div>
                  <button type="submit" className="thm-btn site-footer__newsletter-btn">
                    <span className="thm-btn-text">Subscribe</span>
                    <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="site-footer__top">
        <div className="site-footer__bg" style={{ backgroundImage: 'url(assets/images/17.jpeg)' }}></div>
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
              <div className="footer-widget__column footer-widget__about">
                <div className="footer-widget__about-logo" style={{ display: 'flex', alignItems: 'center' }}>
                  <a href="/" style={{ display: 'inline-block' }}>
                    <img src="assets/images/Rayyan Aid Logo-03.jpg" alt="Rayyan Aid logo" style={{ height: '60px', width: 'auto' }} />
                  </a>
                  <a href="/" style={{ marginLeft: '10px', fontWeight: 800, fontSize: '22px', color: '#ffffff', textDecoration: 'none' }}>Rayyan Aid</a>
                </div>
                <p className="footer-widget__about-text" style={{ textAlign: 'left' }}>Rayyan Aid is a non‑profit dedicated to delivering dignified support across education, healthcare, nutrition and emergency relief. We work alongside communities to create lasting change with transparency and impact.</p>
                <ul className="list-unstyled footer-widget__list">
                  <li>
                    <div className="icon"><span className="icon-pin"></span></div>
                    <div className="text"><p>Abuja, Nigeria</p></div>
                  </li>
                  <li>
                    <div className="icon"><span className="icon-email"></span></div>
                    <div className="text"><p><a href="mailto:info@rayyanaid.org">info@rayyanaid.org</a></p></div>
                  </li>
                  <li>
                    <div className="icon"><span className="icon-call"></span></div>
                    <div className="text"><p><a href="tel:07063653772">07063653772</a></p></div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
              <div className="footer-widget__column footer-widget__gallery clearfix">
                <h3 className="footer-widget__title">Gallery</h3>
                <ul className="footer-widget__gallery-list list-unstyled clearfix">
                  {galleryImages.map((src, idx) => (
                    <li key={idx}>
                      <div className="footer-widget__gallery-img">
                        <img src={src} alt="Footer gallery" />
                        <a href="project-details.html"><span className="fa fa-link"></span></a>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
              <div className="footer-widget__column footer-widget__latest-works clearfix">
                <h3 className="footer-widget__title">Latest News</h3>
                <ul className="footer-widget__latest-works-list list-unstyled clearfix">
                  <li>
                    <div className="footer-widget__latest-works-content">
                      <h4 className="footer-widget__latest-works-title"><a href="blog-details.html">Change your Life Through<br /> Education</a></h4>
                      <p className="footer-widget__latest-works-date">July 29, 2025</p>
                    </div>
                  </li>
                  <li>
                    <div className="footer-widget__latest-works-content">
                      <h4 className="footer-widget__latest-works-title"><a href="blog-details.html">Donate your woolens this<br /> winter</a></h4>
                      <p className="footer-widget__latest-works-date">July 29, 2025</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
              <div className="footer-widget__column footer-widget__twitter-feed clearfix">
                <h3 className="footer-widget__title">Twitter Feed</h3>
                <div className="owl-carousel owl-theme footer-widget__carousel footer-widget__twitter-feed-content">
                  <div className="footer-widget__twitter-feed-single">
                    <p className="footer-widget__twitter-feed-text">Thanks to your support, 3 new boreholes are now providing clean water to 1,200 people in Niger State. <a href="/about">Learn more</a></p>
                    <div className="footer-widget__twitter-feed-bottom">
                      <div className="footer-widget__twitter-feed-icon"><span className="fab fa-twitter"></span></div>
                      <div className="footer-widget__twitter-feed-details">
                        <h5 className="footer-widget__twitter-feed-name">Rayyan Aid <span>@rayyanaid</span></h5>
                        <p className="footer-widget__twitter-feed-time">4 hours ago</p>
                      </div>
                    </div>
                  </div>
                  <div className="footer-widget__twitter-feed-single">
                    <p className="footer-widget__twitter-feed-text">Our school meal program reached 500 additional children this week—attendance is already improving. <a href="/about">See our education work</a></p>
                    <div className="footer-widget__twitter-feed-bottom">
                      <div className="footer-widget__twitter-feed-icon"><span className="fab fa-twitter"></span></div>
                      <div className="footer-widget__twitter-feed-details">
                        <h5 className="footer-widget__twitter-feed-name">Rayyan Aid <span>@rayyanaid</span></h5>
                        <p className="footer-widget__twitter-feed-time">Yesterday</p>
                      </div>
                    </div>
                  </div>
                  <div className="footer-widget__twitter-feed-single">
                    <p className="footer-widget__twitter-feed-text">Rapid response: emergency kits delivered to 300 households after flooding in Kogi. <a href="/contact">Partner with us</a></p>
                    <div className="footer-widget__twitter-feed-bottom">
                      <div className="footer-widget__twitter-feed-icon"><span className="fab fa-twitter"></span></div>
                      <div className="footer-widget__twitter-feed-details">
                        <h5 className="footer-widget__twitter-feed-name">Rayyan Aid <span>@rayyanaid</span></h5>
                        <p className="footer-widget__twitter-feed-time">2 days ago</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="site-footer__bottom">
        <div className="container">
          <div className="site-footer__bottom-inner">
            <p className="site-footer__bottom-text">© 2025 Rayyan Aid. All rights reserved. · Developed by <a href="https://syroltech.com" target="_blank" rel="noopener noreferrer" style={{ color: ' #f59320' }}>Syrol Technologies</a></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
